import React, { useEffect, useState } from "react";
import styles from "./QuestionList.module.scss";
import { isMobileDevice } from "@/app/utils/device";
import {
  CurrentChatStatus,
  Message,
  SocketConnectionStatus,
} from "@/app/store/types";
import { tryParse } from "@/app/utils/object";
import { initSocket, QuestionList } from "@/app/hooks/useClientInit";
import { useMessageStore } from "@/app/store";
import RightArrow from "@/app/icons/rightArrow.svg";
import { ScrollAction, ScrollFrom } from "@/app/hooks/useReadScrollToBottom";
import { ReportScene, reportScene } from "@/app/services/DataReporter";
import Locale from "@/app/locales";
interface IProps {
  msg: Message;
}
export default function QuestionListModule({ msg }: IProps) {
  const { questionList }: { questionList: QuestionList[] } =
    tryParse(msg.content) || {};

  const { updateMessageStatus, setCurrentChatStatus } = useMessageStore();
  const [active, setActive] = useState("");

  useEffect(() => {
    msg.handleScrollToBottom?.(
      ScrollAction.FORCE_TO_BOTTOM,
      ScrollFrom.QUESTION_LIST,
    );
    reportScene(ReportScene.QUESTION_LIST_SHOW);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={`${styles.container} ${isMobileDevice() ? styles.mobile : styles.pc} ${msg.disabled ? styles.disabled : ""}`}
    >
      <p className={styles.title}>{Locale.chat.questionListTitle}</p>
      {questionList && questionList?.length > 0 && (
        <ul className={styles.list}>
          {questionList?.map((item, index) => {
            const id = item.id as string;
            return (
              <li
                className={`${styles.item} ${active === item.id ? styles.active : ""}`}
                key={id + index}
                onClick={() => {
                  if (msg.disabled) {
                    return;
                  }
                  setActive(id);
                  reportScene(
                    ReportScene.QUESTION_LIST_CLICK,
                    item.issueTypeName,
                  );
                  // 更新当前问答消息状态(禁用点击)
                  updateMessageStatus(msg.clientId as string, {
                    disabled: true,
                  });

                  // 注册一个回调，用于更新问题类型发送成功
                  if (typeof window !== "undefined") {
                    //回调执行成功后，销毁回调函数
                    window.globalData = window.globalData || {};
                    window.globalData.serveSocketPreparedCallback = () => {
                      setCurrentChatStatus(CurrentChatStatus.SocketConnected);
                      window.globalData!.serveSocketPreparedCallback =
                        undefined;
                    };
                  }
                  // 初始化socket
                  initSocket(item, async (status) => {
                    if (status === SocketConnectionStatus.ERROR) {
                      updateMessageStatus(msg.clientId as string, {
                        disabled: false,
                      });
                      setActive("");
                    }
                  });
                }}
              >
                <span>{item.issueTypeName}</span>
                <RightArrow />
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
